export default "__VITE_ASSET__62fLWmnh__"